import { deleteAssetsWithConfirm } from 'owa-timestream-asset-sdk';
import { deleteSelectedAssets } from '../actions';
import { getSelectedProjectId } from 'owa-timestream-store';
import { orchestrator } from 'satcheljs';

orchestrator(deleteSelectedAssets, ({ selectedAssets }) => {
    const projectId = getSelectedProjectId();
    deleteAssetsWithConfirm(projectId, selectedAssets);
});
